import { createDuck } from '@/utils'
import { isApp } from '@bcz/fe-interface'

import { ALI_CLIENT_PAY, WX_GZH_PAY, getSupportMayMethod } from '@/utils/confirmUtils'
import { fetchData, getPostageCollect } from '@/services/api/confirm'
import { Toast } from 'antd-mobile-v2'
import { getPaymentPreInfo, isObject } from '@/utils/utils'

const getUserSelectCoupon = (userCouponId, list) => {
  if (typeof userCouponId === 'undefined' || !Array.isArray(list)) return {}
  for (let i = 0, len = list.length; i < len; i++) {
    const item = list[i]
    if (item.id === userCouponId) {
      return item
    }
  }
}

/** @type {confirm.ConfirmData} */
const DEFAULT_STATE = {
  payStatus: 0,
  status: 0,
  order: {},
  checkedPayMethod: null,
  selectedCoupon: {},
  curSelectCoupon: null,
  ableUserCoupons: [],
  unableUserCoupons: [],
  payMethods: null,
  showCouponModal: false,
  note: '',
  agree: false,
  userAgreement: false,

  /**
   * 是否参与铜板购
   */
  canUseCopper: false,
  /**
   * 用户是否使用铜板抵扣
   */
  usePoint: true,

  /**
   * 定金预售本地
   */
  preAgree: false,
  /**
   * 定金预售服务器返回
   */
  preSell: false,

  /**
   *  凑邮商品
   */
  postageGoods: [],
}
export const duck = createDuck({
  name: 'confirmDuck',
  /** @type {confirm.ConfirmData} */
  initialState: {
    ...DEFAULT_STATE,
  },
  actions: {
    /**
     * 获取凑单商品
     */
    getPostageCollect() {
      // getPostageCollect
      return async dispatch => {
        getPostageCollect().then(({ data, error }) => {
          if (!error) {
            const { list } = data
            dispatch(
              duck.change({
                postageGoods: Array.isArray(list) ? list : [],
              }),
            )
          }
        })
      }
    },
    /**
     * 订单确认页
     * @param {confirmApi.ConfirmInform} param
     * @returns
     */
    fetchData(param) {
      return async (dispatch, getState) => {
        const { data, error } = await fetchData(param)
        const { confirmDuck } = getState()

        if (!error) {
          const {
            unableUserCoupons,
            userAgreement,
            nowTime,
            stockoutGoods,
            preSellActivityInfo,
            preSell,
          } = data
          if (!data.order) return
          const order = isObject(data.order) ? data.order : {}
          const { userCouponId, orderItems, stepPay, benefits } = order
          const { discountBenefits } = benefits || {}
          const { subItemId: _subItemId, count: _count } = orderItems[0]
          // const copperStatus = -1
          const _copperArr = Array.isArray(discountBenefits)
            ? discountBenefits.filter(item => {
                return item.activityType === 14 //铜板换购
              })
            : []
          const {
            autoRecommendCoupon,
            pointRequest: { usePoint },
            ...ot
          } = param

          //都为ture时，需要重新发请求，商城方面活动不互斥，但是百词斩商城是互斥的
          if (autoRecommendCoupon && usePoint) {
            //铜板不足 或者不参与铜板购的活动
            if (_copperArr.length === 0) {
              dispatch(
                duck.change({
                  canUseCopper: false,
                }),
              )
              //重新发请求
              return dispatch(
                duck.fetchData({
                  autoRecommendCoupon: true,
                  pointRequest: {
                    usePoint: false,
                  },
                  ...ot,
                }),
              )
            } else {
              dispatch(
                duck.change({
                  canUseCopper: true,
                }),
              )
              return dispatch(
                duck.fetchData({
                  autoRecommendCoupon: false,
                  pointRequest: {
                    usePoint: true,
                  },
                  ...ot,
                }),
              )
            }
          }

          let totalPoint = 0
          let totalDiscountAmount = 0
          _copperArr.map(item => {
            totalPoint += item.point
            totalDiscountAmount += item.discountAmount
          })

          if (Array.isArray(stockoutGoods) && stockoutGoods.length > 0) {
            return dispatch(
              duck.change({
                status: 2,
                stockoutGoods,
              }),
            )
          }

          const ableUserCoupons = Array.isArray(data.ableUserCoupons) ? data.ableUserCoupons : []

          const _pre = getPaymentPreInfo(preSellActivityInfo, _subItemId)

          //获取用户选中的优惠券 22829608,
          const selectedCoupon = getUserSelectCoupon(userCouponId, ableUserCoupons) || {}
          //userCouponId
          dispatch(
            duck.change({
              status: 1,
              order: { ...order, totalDiscountAmount, totalPoint },
              usePoint: usePoint,
              curSelectCoupon: { ...selectedCoupon },
              selectedCoupon: { ...selectedCoupon },
              ableUserCoupons: ableUserCoupons,
              unableUserCoupons: Array.isArray(data.unableUserCoupons) ? unableUserCoupons : [],
              payMethods: getSupportMayMethod(false, { stepPay: stepPay }),
              showCouponModal: false,
              paymentPreInfo: {
                ..._pre,
                count: _count,
              },
              agree: confirmDuck.agree ? confirmDuck.agree : userAgreement,
              userAgreement,

              preAgree: confirmDuck.preAgree ? confirmDuck.preAgree : preSell,
              preSell,
              nowTime,
            }),
          )
        } else {
          // TODO
          Toast.info(error.message || '获取订单数据失败')
        }
      }
    },

    changeStockoutGoods(stockoutGoods) {
      return async (dispatch, getState) => {
        const { confirmDuck } = getState()
        return dispatch(
          duck.change({
            ...confirmDuck,
            status: 2,
            stockoutGoods,
          }),
        )
      }
    },

    clearData() {
      return async dispatch => {
        dispatch(
          duck.change({
            ...DEFAULT_STATE,
          }),
        )
      }
    },

    /**
     *
     * @param {*} val
     * @returns
     */
    changeAgree(val) {
      return async dispatch => {
        dispatch(
          duck.change({
            agree: val,
          }),
        )
      }
    },
    /**
     *
     * @param {*} val
     * @returns
     */
    changePreAgree(val) {
      return async dispatch => {
        dispatch(
          duck.change({
            preAgree: val,
          }),
        )
      }
    },
    /**
     * 初始化支付方式
     * @param { string} initCode
     * @returns
     */
    initPayMethod(initCode) {
      const code = initCode ? initCode : isApp ? ALI_CLIENT_PAY : WX_GZH_PAY
      return async dispatch => {
        dispatch(
          duck.change({
            checkedPayMethod: Number(code),
          }),
        )
      }
    },
    changeNote(val) {
      return async dispatch => {
        dispatch(
          duck.change({
            note: val,
          }),
        )
      }
    },

    changePayingStatus(val) {
      return async dispatch => {
        dispatch(
          duck.change({
            payStatus: val,
          }),
        )
      }
    },

    /**
     * 修改选中的优惠券
     */
    changeSelectedCoupon(data) {
      return async dispatch => {
        // const { confirmDuck } = getState()
        dispatch(
          duck.change({
            curSelectCoupon: data,
          }),
        )
      }
    },
    /**
     * 确认最终使用的 优惠券
     * @param {confirmApi.ConfirmInform} data
     * @returns
     */
    confirmUserCoupon(data) {
      return async dispatch => {
        //发请求
        dispatch(duck.fetchData(data))
      }
    },

    /**
     * 修改弹出状态
     * @param {*} val
     * @returns
     */
    changeCouponModal(val) {
      return async dispatch => {
        dispatch(
          duck.change({
            showCouponModal: val,
          }),
        )
      }
    },
    changePayMethod(data) {
      return async dispatch => {
        dispatch(
          duck.change({
            checkedPayMethod: data,
          }),
        )
      }
    },
  },
})
